import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, ViewChild, OnDestroy, OnChanges, SimpleChanges } from "@angular/core";
import { Table } from 'primeng/table';
import { CommonService, StorageService, TrackingService } from "../../air/modules/common/service";
import { ShipmentService } from "../../air/modules/common/service/shipments/shipment.service";
import { FilterService } from "../../air/modules//common/service/filter/filter.service";
import { SubSink } from "subsink";
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { MessageService } from "primeng/api";
import { UserControlService } from "../../air/modules/common/service/userControl/user-control.service";

import { VesselService } from '../../air/modules/common/service/vessel/vessel.service';


@Component({
    selector: 'app-direct-link-list-details',
    templateUrl: './direct-link-list-details.component.html',
    styleUrls: ['./direct-link-list-details.component.scss'],
    standalone: false
})
export class DirectLinkListDetailsComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild("table") table: Table;
    @ViewChild("eventTable", { static: false }) dataTable: any;
    @Output() move = new EventEmitter();
    @Output() updateShipment = new EventEmitter();

    @Input() shipmentId: any;
    @Input() shipmentStatus;

    tableStyles: any = {
        "max-height": "30.9em",
        "margin-top": "16px",
    };
    tableSettings: any = {
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 75, 100],
        firstAtPage: 0,
        showJumpToPageDropdown: false,
    };
    colspanValueToggledChecked: number;
    unReadCount: number = 0;
    isAlertSubcribed: boolean = false;
    isCurrentLocationVisible: boolean = true;
    keyRef: any = {};
    private subscription = new SubSink();
    public shipmentDetails: any = {};
    public isFileMilestones: boolean = false;

    public vesselStatus: string;
    public alertList: any = [];
    public generalInfo: any = [];
    public etaInformation: any = [];

    public currentLocation: any;
    public origin: any = [];
    public inTransit: any = [];
    public destination: any = [];
    public containerDetails: any = [];
    public logisticMilestones: any = [];
    public fileMilestone: any = [];
    public historicalRoute: any = [];
    public futureRoute: any = [];
    public eventsFull: any = [];
    public eventsLegs;
    public checked: boolean;
    public isReadyToServe: number; // For checking live track pending.
    public adminFile: any;
    public cargoTypeFlag: any;
    public geoFenceFlagForFull: any = [];
    public geoFenceFlagForLeg: any = [];
    public cargoType: any;
    public generalInformationLabels: any;
    public etaInformationLabels: any;
    public flightInformationLabels: any;
    public currentLocationLabels: any;
    public originLabels: any;
    public inTransitLabels: any;
    public destinationLabels: any;
    public fileMilestonesLabels: any;
    public isViewDocDisabled: boolean = true;
    public logisticMisestonesColumns: any = [];
    public containerDetailsColumns: any = [];
    showTranshipmentTable: boolean = true;
    actSendDatePresent: boolean;
    actRecieveDatePresent: boolean;
    fullURL: string;
    copiedURL: string;
    etaInformationTooltips: any;
    contanierRefKey: string = "containerNumber";
    containerNumbers: any = [];
    etaConfigType: number;
    exceptionShipmentStatus: number;
    isActiveShipment: boolean = true;
    docsOnly: boolean = false;
    first: number = 0;
    public documentDistributionList: any = [];
    public documentTypeList: any = [];
    public isDocumentDistribution: boolean = true;
    public selectedRowData: any = [];
    public documentSelected: boolean = true;
    public isDocumentDistributionWithData: boolean = false;
    public selectedDocumentTypes: any[] = [];
    emptyMessageForDocumentDistributionList: string;
    emptyMessageForDocumentList: string;
    loading: boolean;
    shipmentStatusType: any;
    shipmentEvent: any;
    additionalFileMilestones = [];
    public additionalFileMilestonesLabels: any;
    groupedHistoricalRoute: {
        flightNumber: string;
        routes: any;
        futureRoutes: any;
    }[];
    isDocOnly: boolean = false;
    hasProcessed: any;
    key: string;
    flightResponse: any = [];
    constructor(
        private trackingService: TrackingService,
        private commonService: CommonService,
        private ref: ChangeDetectorRef,
        private shipmentService: ShipmentService,
        private filterService: FilterService,

        private activatedRoute: ActivatedRoute,
        private vesselSerive: VesselService,
        private router: Router,
        private messageService: MessageService,
        private userControlService: UserControlService,
        public storageService: StorageService
    ) {

        this.activatedRoute.fragment.subscribe(fragment => {
            const url = new URL(window.location.href);
            const pathSegments = url.hash.split('/');
            this.key = pathSegments[pathSegments.length - 1];

            this.subscription.add(
                this.trackingService.getDirectLinkAccess(this.key).subscribe({
                    next: (res: any) => {
                        if (res.data?.shipmentId) {
                            this.shipmentId = res.data.shipmentId;
                            this.getFlightRouteDetails(this.shipmentId);
                            // Call other APIs after getting shipmentId
                            this.subscription.add(
                                forkJoin({
                                    shipment: this.trackingService.getShipmentInfo(this.shipmentId),
                                }).subscribe(({ shipment }: any) => {
                                    // const {
                                    //     shipmentInformation,
                                    //     locationInformation,
                                    //     routingInfo,
                                    //     shipmentEvent,
                                    //     fileMilestone,
                                    // } = shipment.data;
                                    const {
                                        etaInformation,
                                        generalInfo,
                                        flightResponse,
                                        shipmentEvent,
                                        fileMilestone
                                    } = shipment.data;

                                    if (shipment.data.generalInfo.shipmentStatusCode == 8) {
                                        this.isDocOnly = true;
                                        this.isFileMilestones = true;
                                    }

                                    this.shipmentDetails.shipmentId = this.shipmentId;
                                    const data = JSON.parse(JSON.stringify(generalInfo));
                                    this.clearArrays();

                                    data.containerDetails = this.containerDetails;
                                    let tempArray = [];
                                    this.containerNumbers = [];
                                    this.isReadyToServe = this.shipmentDetails.isReadyToServe;
                                    this.cargoTypeFlag = this.shipmentDetails.cargoTypeFlag;
                                    this.adminFile = this.shipmentDetails.adminFile;
                                    this.cargoType = this.shipmentDetails.cargoType;
                                    this.shipmentStatusType = this.shipmentDetails.shipmentStatus;

                                    // Added for displaying message for inactive shipments.
                                    this.isActiveShipment = this.shipmentDetails.status == "Inactive" ? false : true;

                                    this.trackingService.isTransshipmentPromise.next(this.shipmentDetails.isTransshipment);
                                    this.updateShipment.emit(data);
                                    this.isCurrentLocationVisible = generalInfo.isReadyToServe;

                                    // Process general information
                                    for (var key in generalInfo) {
                                        let object;
                                        if (this.generalInformationLabels[key]) {
                                            if (this.generalInformationLabels[key] != "POL UNLOC" && this.generalInformationLabels[key] != "POD UNLOC") {
                                                switch (key) {
                                                    case 'departAirport':
                                                        const departIata = generalInfo['departIata'];
                                                        object = {
                                                            label: this.generalInformationLabels[key],
                                                            value: departIata ? `${generalInfo[key]} (${departIata})` : generalInfo[key]
                                                        };
                                                        break;

                                                    case 'arriveAiport':
                                                        const arriveIata = generalInfo['arriveIata'];
                                                        object = {
                                                            label: this.generalInformationLabels[key],
                                                            value: arriveIata ? `${generalInfo[key]} (${arriveIata})` : generalInfo[key]
                                                        };
                                                        break;

                                                    case 'Progress':
                                                        object = {
                                                            label: this.generalInformationLabels[key],
                                                            value: generalInfo[key] + " %",
                                                        };
                                                        break;

                                                    case 'Status':
                                                        object = {
                                                            label: this.generalInformationLabels[key],
                                                            value: generalInfo[key],
                                                        };
                                                        this.vesselStatus = generalInfo[key];
                                                        break;

                                                    default:
                                                        if (this.generalInformationLabels[key]?.includes("Date")) {
                                                            object = {
                                                                label: this.generalInformationLabels[key],
                                                                value: this.commonService.formatDate(generalInfo[key], true),
                                                            };
                                                        } else {
                                                            object = {
                                                                label: this.generalInformationLabels[key],
                                                                value: generalInfo[key],
                                                            };
                                                        }
                                                }

                                                if (object?.value && object?.label) {
                                                    this.generalInfo.push(object);
                                                }
                                            }
                                        }
                                    }

                                    // Process ETA information
                                    // Process ETA information
                                    for (var key in etaInformation) {
                                        let object;
                                        if (key.includes("Eta")) {  // Changed from "Date" to "Eta" since these are ETA fields
                                            object = {
                                                label: this.etaInformationLabels[key],
                                                value: etaInformation[key] ?
                                                    `${moment(etaInformation[key]).format('DD MMMM YYYY HH:mm:ss')} (${etaInformation.timeZone || 'GMT'})` :
                                                    'N/A',
                                                description: this.etaInformationTooltips[key],
                                            };
                                        } else if (key === 'timeZone') {

                                            continue;
                                        } else {
                                            object = {
                                                label: this.etaInformationLabels[key],
                                                value: etaInformation[key] || 'N/A',
                                                description: this.etaInformationTooltips[key],
                                            };
                                        }

                                        if (object.label && object.value !== 'N/A') {
                                            this.etaInformation.push(object);
                                        }
                                    }
                                    // Process flight information
                                    for (var key in flightResponse) {
                                        let object = {
                                            label: this.flightInformationLabels[key],
                                            value: flightResponse[key],
                                        };
                                        if (object.label && object.value != null) {
                                            this.flightResponse.push(object);
                                        }
                                    }


                                    //   Handle shipment event details
                                    this.containerDetails = shipmentEvent.events.map((event) => {
                                        if (event?.eventDescription.includes("Date")) {
                                            event.eventDescription = event.eventDescription;
                                        }
                                        // if (event.locationName && event.locationName != "undefined" && event.locationName != "" && event.locationName != null && event.locationName != "") {
                                        //     event.locationName = `${event.locationName} (${event.locationName})`;
                                        // }
                                        if (event.locationName && event.locationName != "undefined" && event.locationName != "") {
                                            event.locationName = `${event.locationName} (${event.iata})`;
                                        }
                                        if (event.estimateDate) {
                                            event.estimateDate = event.estimateDate;
                                        }
                                        if (event.actualDate) {
                                            event.actualDate = event.actualDate;
                                        }
                                        return event;
                                    });

                                    // Handle shipment file milestone details
                                    this.fileMilestone = [];
                                    this.additionalFileMilestones = [];
                                    for (let key in fileMilestone) {
                                        if (key === "shipmentId" || key === "id" || key === "reference") {
                                            continue;
                                        }
                                        if (fileMilestone[key] == "0000-00-00 00:00:00" || fileMilestone[key] == null) {
                                            fileMilestone[key] = " ";
                                        } else {
                                            const dateStr = fileMilestone[key];
                                            if (moment(dateStr, moment.ISO_8601, true).isValid()) {
                                                const date = moment(dateStr);
                                                fileMilestone[key] = date.format("DD MMMM YYYY");
                                            }
                                        }

                                        let object = {
                                            label: this.fileMilestonesLabels[key],
                                            value: fileMilestone[key],
                                        };

                                        if (this.additionalFileMilestonesLabels.hasOwnProperty(key)) {
                                            object.label = this.additionalFileMilestonesLabels[key];
                                            if (object.value) {
                                                this.additionalFileMilestones.push(object);
                                            }
                                        } else if (object.value) {
                                            this.fileMilestone.push(object);
                                        }
                                    }

                                    if (this.additionalFileMilestones != null) {
                                        let object = {
                                            label: "Additional File Milestones",
                                        };
                                        this.fileMilestone.push(object);
                                    }

                                    this.hasProcessed = true;

                                    this.fileMilestone.map((milestone) => {
                                        if (milestone.label.includes("Send Actual")) {
                                            if (milestone.value != null && milestone.value != " ") {
                                                this.actSendDatePresent = true;
                                            }
                                        }
                                        if (milestone.label.includes("Receive Actual")) {
                                            if (milestone.value != null && milestone.value != " ") {
                                                this.actRecieveDatePresent = true;
                                            }
                                        }
                                    });
                                })
                            );
                        } else {
                            this.messageService.add({
                                key: 'errorToaster',
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Link key has expired'
                            });
                        }
                    },
                    error: (error) => {
                        console.error('Error:', error);
                        this.messageService.add({
                            key: 'errorToaster',
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Link key has expired or is invalid'
                        });
                    }
                })
            );
        });
        // this.trackingListLink = [this.commonService.getRoute({ route: AppRoutes.User.TRACKING_LIST, type: 'User' })];

        this.colspanValueToggledChecked = 5;
        this.generalInformationLabels = {
            bdpRefno: "Forwarder Ref No.",
            bdpRepresentName: "Representative Name",
            companyName: "Company Name",
            departAirport: "Airport Departure Name",
            departCountry: "Airport Departure Country",
            departRegion: "Airport Departure Region",
            departTimezone: "Airport Departure Timezone",
            arriveAiport: "Airport Arrival Name",
            arriveCountry: "Airport Arrival Country",
            arriveRegion: "Airport Arrival Region",
            arrvlTimeZone: "Airport Arrival Timezone",
            //   scheduleStatus: "Status",
            purchaseOrderNumber: "Purchase Order Number",
            shipperRefNumber: "Shipper Reference Number",
            awbNumber: "Master AWB number",
            houseBillNumber: "House Bill Number",
            //    airlineName: "Airline Name",
            carrierName: "Carrier Name",
            //  airlineIata: "Airline IATA code",  // Not coming from backend 
            carbonEmission: "CO\u2082 Emission"
        }
        this.etaInformationLabels = {
            currentEta: "Carrier Current ETA",
            originalBookingEta: "Original Booking ETA",
            originalDepartureEta: "Original Departure ETA",
        };

        this.etaInformationTooltips = {
            currentEta:
                "The last Estimated Time of Arrival update provided by the Carrier.",
            originalBookingEta:
                "Estimated Time of Arrival at the time of booking.",
            originalDepartureEta:
                "Estimated Time of Arrival at the time of actual departure.",
        };

        this.flightInformationLabels = {
            flightNumber: "Flight Number",
            trans1FlightNumber: "Transhipment 1 Flight Number",
            trans2FlightNumber: "Transhipment 2 Flight Number",
            trans3FlightNumber: "Transhipment 3 Flight Number",
            trans4FlightNumber: "Transhipment 4 Flight Number",
            trans5FlightNumber: "Transhipment 5 Flight Number",

        };

        this.currentLocationLabels = {
            flightNumber: "Flight Number",
            //   airLineName: "Carrier Name",
            latitude: "Latitude",
            longitude: "Longitude",
            //  speed: "Speed",
            speedVertical: "Speed Vertical",
            speedHorizontal: "Speed Horizontal",
            //    status: "Flight Status",
            altitude: "Altitude",
            direction: "Direction",
        };

        this.originLabels = {
            shipFromName: "Ship From Name",
            shipFromAddressLine1: "Ship From Address Line 1",
            shipFromAddressLine2: "Ship From Address Line 2",
            shipFromAddressLine3: "Ship From Address Line 3",
            shipFromAddressLine4: "Ship From Address Line 4",
            shipFromCityName: "Ship From City Name",
            shipFromSatteProvinceCode: "Ship From State Province Code",
            shipFromRegion: "Ship From Region Name",
            shipFromCountryName: "Ship From Country Name",
            shipFromTimeZone: "Ship From Time Zone",
            shipDepartureName: "Ship from Departure Name",
        };

        this.inTransitLabels = {
            transshipArrivalLocation: "Transship #1 Arrival Location",
        };

        this.destinationLabels = {
            portOfArrivalName: "Port of Arrival Name",
            placeOfDeliveryName: "Place of Delivery Name",
            shipToName: "Ship To Name",
            shipToAddressLine1: "Ship To Address Line 1",
            shipToAddressLine2: "Ship To Address Line 2",
            shipToAddressLine3: "Ship To Address Line 3",
            shipToAddressLine4: "Ship To Address Line 4",
            shipToCityName: "Ship to City Name",
            shipToStateProvinceCode: "Ship To State Province Code",
            shipToPostalCode: "Ship To Postal Code",
            shipToRegion: " Ship To Region Name",
            shipToCountryName: "Ship To Country Name",
        };

        this.containerDetailsColumns = [
            {
                header: "Container Number",
                field: "containerNumber",
            },
            {
                header: "Seal Number",
                field: "sealNumber",
            },
            {
                header: "Container Type",
                field: "containerType",
            },
        ];

        this.logisticMisestonesColumns = [
            {
                header: "Event Code",
                field: "event",
            },
            {
                header: "Event Name",
                field: "eventDescription",
            },

            // {
            //     header: "Actual",
            //     field: "actual",
            // },
            {
                header: "Estimated Event Date & Time",
                field: "estimateDate",
            },
            {
                header: "Actual Event Date & Time",
                field: "actualDate",
            },
            {
                header: "Event Location",
                field: "locationName",
            },
            {
                header: "Flight Number",
                field: "flightNumber",
            },
        ];

        this.fileMilestonesLabels = {
            shipmentId: "Shipment ID",
            fileCreationDate: "File Creation",
            originalBookedDate: "Original Booked Date",
            bookingConfirmDate: "Booking Confirm Date",
            documentDistributionSendEstimatedDate:
                "Document Distribution Send Estimated Date",
            documentDistributionReceiveActualDate:
                "Document Distribution Receive Actual Date",
            documentDistributionReceiveEstimatedDate:
                "Document Distribution Receive Estimated Date",
            documentTurnoverDate: "Document Turnover Date",
            customsEntryPermitSubmitDate: "Customs Entry Permit Submit Date",
            orderReceivedDate: "Order Received ",
            requestArrivalDate: "Request Arrival",
            carrierBookingRequestDate: "Carrier Booking Request ",
            carrierBookingConfirmationDate: "Carrier Booking Confirm ",
            carrierReleaseRequestedDate: "Carrier Release Requested Date",
            goodsAvailableDate: "Goods Available ",
            goodsIssueDate: "Goods Issue",
            goodsAvailableShipActualDate: "Goods Available Ship Actual Date",
            goodsAvailableShipEstimateDate:
                "Goods Available Ship Estimate Date",
            vgmSubmittedDate: "VGM Submitted",
            shippingInstructionsSentDate: "Shipping Instructions Sent ",
            exportClearedDate: "Export Cleared",
            finalBlDate: "Final BL",
            docDispatchDate: "Doc Dispatch",
            documentDispatchDate: "Document Dispatch Date",
            importClearedDate: "Import Cleared",
            truckingInstructionsBookedDate: "Trucking Instructions Booked",
            truckingInstructionsSentDate: "Trucking Instructions Sent Date",
            invoiceReleaseDate: "Invoice Release Date",
            invoiceActualDate: "Invoice Actual Date",
            additionalFileMilestones: "Additional File Milestones",
        };

        this.additionalFileMilestonesLabels = {
            bolSubmitDate: "BOL Submit Date",
            billOfLadingSubmitDate: "Bill of Lading Submit Date",
            bookingDate: "Booking Date",
            bolActionDate: "BOL Action Date",
            bolPostAuditBackDate: "BOL Post Audit Back Date",
            bolPreAuditReceiveDate: "BOL Pre Audit Receive Date",
            bookingConfirmationReceivedFromSsDate:
                "Booking Confirmation Received From SS Date",
            bookingConfirmationSentToCustomerDate:
                "Booking Confirmation Sent To Customer Date",
            bookingConfirmationReceivedFromCarrierDate:
                "Booking Confirmation Received From Carrier Date",
            customsEntryPermitNumber: "Customs Entry Permit Number",
            customsEntryPermitReleaseDate: "Customs Entry Permit Release Date",
            customersEntryPermitReleaseDate:
                "Customers Entry Permit Release Date",
            customsEntryPermitSubmitDate: "Customs Entry Permit Submit Date",
            deliveryOrderCreationActualDate:
                "Delivery Order Creation Actual Date",
            destinationInlandDeliveryActualDate:
                "Destination Inland Delivery Actual Date",
            destinationInlandDeliveryEstimatedDate:
                "Destination Inland Delivery Estimated Date",
            destinationInlandLocationName: "Destination Inland Location Name",
            documentDistributionReceiveActualDate:
                "Document Distribution Receive Actual Date",
            documentDistributionSendActualDate:
                "Document Distribution Send Actual Date",
            exporter: "Exporter",
            feederVesselActualLoadDate: "Feeder Vessel Actual Load Date",
            governmentPermissionToExportReleaseDate:
                "Government Permission To Export Release Date",
            governmentPermissionToExportReleaseNumber:
                "Government Permission To Export Release Number",
            governmentPermissionToExportSubmitDate:
                "Government Permission To Export Submit Date",
            grossTransactionKiloQuantity: "Gross Transaction Kilo Quantity",
            hazardousMaterialIndicator: "Hazardous Material Indicator",
            importer: "Importer",
            latestDeliveryCutoffDate: "Latest Delivery Cutoff Date",
            manufacturingPlantCode: "Manufacturing Plant Code",
            manufacturingPlantName: "Manufacturing Plant Name",
            portOfEntryName: "Port of Entry Name",
            purchaseOrderNumberConcat: "Purchase Order Number",
            regionOfDestinationName: "Region of Destination Name",
            regionOfOriginName: "Region of Origin Name",
            requestEtaDestinationDate: "Request ETA Destination Date",
            sbuCode: "SBU Code",
            shipperReferenceNumber: "Shipper Reference Number",
            totalFreightBolAwbCollectAmount:
                "Total Freight BOL AWB Collect Amount",
            totalFreightBolAwbCollectAmountCurrencyCode:
                "Total Freight BOL AWB Collect Amount Currency Code",
            totalFreightBolAwbPrepaidAmount:
                "Total Freight BOL AWB Prepaid Amount",
            totalFreightBolAwbPrepaidAmountCurrencyCode:
                "Total Freight BOL AWB Prepaid Amount Currency Code",
            twentyFootEquivalentUnitQuantity:
                "Twenty Foot Equivalent Unit Quantity",
            notifyName: "Notify Name",
            originCountryName: "Origin Country Name",
            originInlandPickupActualDate: "Origin Inland Pickup Actual Date",
            originalPortOfDepartureEstimateDate:
                "Original Port Of Departure Estimate Date",
            portOfEntryUnloc: "Port of Entry UNLOC",
        };

        this.alertList = [];
    }

    getFlightRouteDetails(shipmentId) {
        this.subscription.add(
            this.vesselSerive.getCoveredRoute(shipmentId).subscribe((response: any) => {
                this.shipmentStatus = response.shipmentStatus;
                const locationData = response.data?.flightLocation || {};

                // This will hold the formatted display values
                this.currentLocation = [];

                for (const key in locationData) {
                    if (this.currentLocationLabels[key]) {
                        const value = locationData[key];
                        if (value !== null && value !== undefined) {
                            this.currentLocation.push({
                                label: this.currentLocationLabels[key],
                                value: value
                            });
                        }
                    }
                }
            })
        );
    }



    resetSort() {
        //  this.table.sortOrder = 1;
        this.first = 0;
        this.table._rows = 10;
        this.table.sortField = "docTypeName";
        this.table.reset();
    }

    onInputToggleChange(ev) {
        if (ev) {
            this.colspanValueToggledChecked = 4;
            this.logisticMisestonesColumns = [
                {
                    header: "Event Name",
                    field: "event",
                },

                // {
                //     header: "Actual",
                //     field: "actual",
                // },
                {
                    header: "Estimated Event Date & Time",
                    field: "estimateDate",
                },
                {
                    header: "Actual Event Date & Time",
                    field: "actualDate",
                },
                {
                    header: "Event Location",
                    field: "locationName",
                },
                {
                    header: "Flight Number",
                    field: "flightNumber",
                },
            ];
        } else {
            this.colspanValueToggledChecked = 5;
            this.logisticMisestonesColumns = [
                {
                    header: "Event Code",
                    field: "event",
                },
                {
                    header: "Event Name",
                    field: "eventDescription",
                },

                // {
                //     header: "Actual",
                //     field: "actual",
                // },
                {
                    header: "Estimated Event Date & Time",
                    field: "estimateDate",
                },
                {
                    header: "Actual Event Date & Time",
                    field: "actualDate",
                },
                {
                    header: "Event Location",
                    field: "locationName",
                },
                {
                    header: "Flight Number",
                    field: "flightNumber",
                },
            ];
        }
    }
    ngOnInit() {
        this.activatedRoute.paramMap.subscribe((params) => {
            this.shipmentId = params.get("shipmentid");
            //   console.log("Shipment ID:", this.shipmentId); // Debug statement
            if (this.shipmentId) {
                this.customeNgOnInit();
                this.keyRef.value = "";
            }
        });
        // Process general information
    }

    customeNgOnInit(): void {
        // this.shipmentService.updateRecentShipment({
        //     shipmentId: this.shipmentId
        // }, true);
        this.generalInfo = [];
        this.etaInformation = [];
        this.generalInfo = [];
        this.currentLocation = [];
        this.origin = [];
        this.inTransit = [];
        this.destination = [];
        this.containerDetails = [];
        this.logisticMilestones = [];
        this.fileMilestone = [];
        this.historicalRoute = [];
        this.futureRoute = [];
        this.eventsFull = [];
        this.alertList = [];
        this.containerNumbers = [];
        //  this.getAlertsList();
        this.activatedRoute.paramMap.subscribe((params) => {
            this.shipmentId = params.get("shipmentid");
        });

    }

    getRouteInfo() {
        this.subscription.add(
            this.trackingService
                .getRouteInfo(this.shipmentId)
                .subscribe((res) => {
                    if (res != null && res != undefined) {
                        res.map((element) => {
                            if (element.actual) {
                                this.historicalRoute.push({
                                    vesselImo: element.vesselImo,
                                    dateAndTime:
                                        moment(
                                            new Date(element.dateAndTime)
                                        ).format("DD MMMM YYYY HH:mm:ss") +
                                        " GMT",
                                    coordinates: element.coordinates,
                                });
                            } else {
                                this.futureRoute.push({
                                    vesselImo: element.vesselImo,
                                    dateAndTime:
                                        moment(
                                            new Date(element.dateAndTime)
                                        ).format("DD MMMM YYYY HH:mm:ss") +
                                        " GMT",
                                    coordinates: element.coordinates,
                                });
                            }
                        });
                        this.historicalRoute = this.historicalRoute.reverse();
                    }
                })
        );
    }

    detectTabChange(data) {
        if (data.index == 2) {
            if (this.dataTable) {
                setTimeout(() => {
                    this.dataTable.resetScrollTop();
                    this.dataTable.reset();
                }, 500);
            }
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.trackingService.isTransshipmentPromise.next(0);
        this.trackingService.isHazardousPromise.next("N");
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.shipmentId) {
            this.customeNgOnInit();
            //  this.resetSort();
        }
    }

    setContainerKeyRefValue(keyRef: any) {
        this.containerNumbers = [];
        if (this.containerDetails.length > 0) {
            for (var index in this.containerDetails) {
                this.containerNumbers.push(
                    this.containerDetails[index][this.contanierRefKey]
                );
            }

            if (this.containerNumbers.length > 0) {
                keyRef.containerCount = this.containerNumbers.length;
                keyRef.value = this.containerNumbers.slice(0, 3).join(", ");
                keyRef.toolTip = this.containerNumbers.join(", ");
            }
            this.keyRef = keyRef;
        } else {
            this.setDefaultBDPRefKey();
        }
    }

    //Set to BDP Ref key if no value is present for other key ref
    setDefaultBDPRefKey() {
        this.keyRef = {
            key: "bdpReferenceNumber",
            label: "Forwarder Ref No. ",
            value: this.generalInfo.forwardedRefNo,
            shortLabel: "Forwarder Ref No. ",
            keyIndex: 1,
        };
    }
    private clearArrays(): void {
        this.generalInfo.length = 0;
        this.etaInformation.length = 0;
        this.generalInfo.length = 0;
        this.currentLocation.length = 0;
        this.origin.length = 0;
        this.destination.length = 0;
    }
}
